import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowLeft, Heart, Star } from "lucide-react";
import { Link } from "react-router-dom";

const BETA_HEROES = [
  "Juan Ignacio Cornudella Lema",
  "Joan Trias Castrillo",
  "Sergi Teixidor Abián",
  "German Herranz Cayuela",
];

const Credits = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="p-4 space-y-6 max-w-screen-xl mx-auto">
        <header className="flex items-center gap-4">
          <Button asChild variant="ghost" size="icon" className="shrink-0">
            <Link to="/profile">
              <ArrowLeft className="w-6 h-6" />
            </Link>
          </Button>
          <div className="flex items-center gap-3">
            <div className="bg-secondary/10 p-3 rounded-xl text-secondary">
              <Heart className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-2xl font-bold">{t("credits_title")}</h1>
              <p className="text-sm text-muted-foreground">{t("credits_subtitle")}</p>
            </div>
          </div>
        </header>

        <Card className="p-5 space-y-2">
          <h2 className="font-semibold">{t("credits_developed_by")}</h2>
          <p className="text-sm text-muted-foreground">{t("credits_developed_by_text")}</p>
        </Card>

        <Card className="p-5 space-y-4">
          <div className="flex items-center gap-2">
            <Star className="w-5 h-5 text-secondary" />
            <h2 className="font-semibold">{t("credits_beta_heroes")}</h2>
          </div>
          <p className="text-sm text-muted-foreground">{t("credits_beta_heroes_text")}</p>
          <div className="space-y-2">
            {BETA_HEROES.map((name) => (
              <div key={name} className="flex items-center gap-3 rounded-lg bg-secondary/5 border border-secondary/10 px-4 py-3">
                <div className="w-8 h-8 rounded-full bg-secondary/20 flex items-center justify-center text-sm font-bold text-secondary">
                  {name.charAt(0)}
                </div>
                <span className="text-sm font-medium">{name}</span>
              </div>
            ))}
          </div>
        </Card>

        <Card className="p-5 space-y-2">
          <h2 className="font-semibold">{t("credits_tech")}</h2>
          <p className="text-sm text-muted-foreground">{t("credits_tech_text")}</p>
        </Card>

        <div className="text-center text-xs text-muted-foreground pt-4">
          <p>{t("credits_made_with_love")}</p>
        </div>
      </div>
    </div>
  );
};

export default Credits;
